<template>
  <!-- 视频播放页面 -->
  <div id="detail-video">
    <!-- <div class="top-title">
      <img src="../../assets/img/login-img/3-1档案-返回ic@2x.png" alt="" class="back-icon" @click="goBack">
      <p class="title-text siyuan-bold">{{itemData.group_name}}</p>
    </div>-->
    <ul class="video-wrapper">
      <!-- <li class="video-item" v-for="(item, index) in itemData.spjh" :key="index">  //多视频版本-->
      <!-- 单视屏版本 -->
      <li class="video-item" ref="playerRef">
        <!-- end -->
        <img
          v-if="showShdow"
          src="../../assets/img/common-img/video-top-shdow@2x.png"
          alt=""
          class="top-shdow"
        >
        <tc-player
          v-show="!isShowBuyPanel"
          ref="player"
          @videoplay="videoPlay"
          @videoended="videoEnded"
          class="tc-player"
          :itemName="itemData.tag_name"
          :isAutoLoad="isAutoLoad"
          :itemId="itemId"
        ></tc-player>
      </li>
    </ul>
    <!-- 试看面板 -->
    <div class="pay-panel" v-if="itemData.issf == '1' && !itemData.jf && prepareWatch">
      <img class="cover-url" :src="itemData.image" alt="">
      <img class="mask" src="@/assets/img/videoDetail/mask.png" alt="">
      <template v-if="isMinProgamme">
        <img
          @click="prepareToWatch"
          class="shown-btn-2"
          src="@/assets/img/videoDetail/preWatch.png"
          alt=""
        >
      </template>
      <template v-else>
        <!-- 试看按钮 -->
        <img
          @click="prepareToWatch"
          class="shown-btn"
          src="@/assets/img/videoDetail/shown-btn.png"
          alt=""
        >
        <!-- 完整观看 -->
        <img
          @click="buyVideo"
          class="full-watch-btn"
          src="@/assets/img/videoDetail/full-watch.png"
          alt=""
        >
        <div v-if="group_id == 69" class="discount-bg full">{{ parseInt(itemData.spjg)/100 }}元抢先看</div>
        <div v-else class="discount-bg full">优惠价仅{{ parseInt(itemData.spjg)/100 }}元</div>
      </template>
    </div>
    <!-- 付费面板 -->
    <!-- v-show="isShowBuyPanel" -->
    <div class="pay-panel pay" v-if="isShowBuyPanel">
      <!-- <p >试看结束，本片需购买观看，请先购买</p> -->
      <p v-if="isMinProgamme" style="top: 50%;transform: translateY(-50%)">小程序暂不支持观看，请到公众号观看</p>
      <p
        v-if="!isMinProgamme && group_id != 69"
      >主人，原创不易，打赏{{ parseInt(itemData.spjg)/100 }}元，我就是你的人啦！</p>
      <p v-if="!isMinProgamme && group_id == 69">主人，原创不易，打赏{{ parseInt(itemData.spjg)/100 }}元抢先看哦</p>
      <!-- 立即购买 -->
      <img
        v-if="!isMinProgamme"
        @click="buyVideo"
        class="buy-at-once"
        src="@/assets/img/videoDetail/buy.png"
        alt=""
      >
      <!-- 优惠价 -->
      <div
        v-if="!isMinProgamme && group_id != 69"
        @click="buyVideo"
        class="discount-bg desc"
      >优惠价仅{{ parseInt(itemData.spjg)/100 }}元</div>
      <div
        v-if="!isMinProgamme && group_id == 69"
        @click="buyVideo"
        class="discount-bg desc"
      >{{ parseInt(itemData.spjg)/100 }}元抢先看</div>
    </div>
    <!-- 下划线 -->
    <div class="border-wrapper">
      <div class="border-box"></div>
    </div>
    <!-- end -->
    <!-- 视频里面的提示 -->
    <div class="video-tips" v-show="showBack">
      <img @click="goBack" src="../../assets/img/common-img/back-icon.png" alt="" class="back-icon">
    </div>
    <!-- end -->
    <div>
      <!-- tab -->
      <div class="tabs-box">
        <span class="tab" @click="setTabIndex(0)" :class="[tabIndex == 0 && 'active' ]">视频</span>
        <span class="row">|</span>
        <span :class="[tabIndex == 1 && 'active' ]" @click="setTabIndex(1)" class="tab">
          图文
          <img
            v-if="itemData.issf == 1 && !itemData.jf"
            class="lock-logo"
            src="@/assets/img/videoDetail/lock2.png"
            alt=""
          >
        </span>
        <p class="line" :class="[tabIndex == 0 ? 'left' : 'right' ]"></p>
      </div>
      <div
        v-show="tabIndex == 1 && !isPlayKownLedgeVideo"
        class="content-box"
        v-html="itemData.zm_content"
      ></div>
      <div
        v-show="tabIndex == 1 && isPlayKownLedgeVideo"
        class="content-box"
        v-html="kownLedgeContent"
      ></div>
      <div v-show="tabIndex == 0" class="content-box noBottom">
        <!-- 视频名称 -->
        <div class="video-name-box">
          <span class="video-name">{{itemData.tag_name}}</span>
          <div class="more-box" :class="{noButtonFlag:itemData.group_name!=='重症手足口病'}">
            <span class="name-tips" :class="{tipsActive:isShowTips}">{{itemData.summary}}</span>
            <img
              src="../../assets/img/see-doctor-icon/1-3jianjiexiala@2x@2x.png"
              alt=""
              class="more-icon"
              @click.stop="isShowTips = !isShowTips"
            >
          </div>
          <van-button
            v-if="itemData.group_name === '重症手足口病'"
            @click="goInsurance"
            type="primary"
            class="go_insurance"
          >点我，给宝宝提供健康保障</van-button>
        </div>
        <!-- end -->
        <!-- 视频图文选集 -->
        <div class="select-box border-css">
          <div class="select-title">
            <span class="title-text">视频选集</span>
            <span class="title-tips">{{itemData.pub_date}} {{itemData.episode_text}}</span>
          </div>
          <div class="select-video-item-box-wrap">
            <div class="select-video-item-box">
              <template v-for="(item, iIndex) in itemData.spjh">
                <div
                  @click="goDetail(item.item_id,iIndex)"
                  class="select-video-item"
                  :class="[computedVideoItemClass(item)]"
                  :key="iIndex"
                >
                  {{ item.tag_name.split('-')[1] }}
                  <img
                    v-if="item.issf == '1' && !item.jf"
                    src="@/assets/img/videoDetail/lock2.png"
                    alt=""
                    class="lock-logo"
                  >
                </div>
              </template>
            </div>
          </div>
        </div>
        <!-- end -->
        <!-- 症状 -->
        <!-- <div class="sorts-box border-css">
        <span class="sorts-name">症状</span>
        <ul class="sorts-tips">
          <li @click="goSearch(item.symptom_name)"  class="tips-item" v-for="(item,index) in itemData.symptoms" :key="index"><span :class="[index==1  && 'special', index>1 && 'normal']">{{item.symptom_name}}</span></li>
        </ul>
        <span class="sorts-other" v-if="false">生育年龄的妇女有进行性加剧的疼痛或伴不</span>
        </div>-->

        <!-- end -->
        <div class="advert-banner">
          <img
            @click="$router.push('/SdInquiry')"
            src="@/assets/img/videoDetail/banner-9.9.png"
            class=""
            alt=""
          >
        </div>
        <div v-if="tabIndex == 0" class="content-box-normal top" style="padding-left:0 ">
          <p class="other-name title-css">相关视频</p>
        </div>
      </div>
      <div
        v-show="tabIndex == 0"
        class="related-video-swiper"
        @touchstart="bindRelateTouchStart"
        @touchend="bindRelateTouchEnd($event)"
        ref="related-swiper-box"
      >
        <template v-for="(item, key) in relateVideos.groupList">
          <div class="video-swiper-item" ref="video-swiper-item" :key="key">
            <!--病种图片与 名字-->
            <p class="header">
              <img class="avatur" :src="item.fmt">
              <span class="b_FS-36 c_333 font-medium">{{ item.group_name }}</span>
            </p>
            <!-- end -->
            <ul>
              <template v-for="(val, itemKey) in item.spjh">
                <li
                  class="relative-video-item"
                  v-if="itemKey< 3"
                  @click="goDetail(val.item_id, itemKey)"
                  :key="itemKey"
                >
                  <img :src="val.image" alt="">
                  <div>
                    <p class="title">{{ val.tag_name.split('-')[1] }}</p>
                    <p class="content">{{ val.video_name.split("：")[1] }}</p>
                  </div>
                </li>
              </template>
              <!-- 广告图 -->
              <li @click="$router.push('/SdInquiry')" class="relative-video-item">
                <img src="@/assets/img/videoDetail/banner1.png" alt="">
                <div>
                  <p class="title">小医院诊断怕误诊</p>
                  <p class="content">9块9问北京专家更放心</p>
                </div>
              </li>
              <li
                @click="$router.push('/SdInquiry')"
                class="relative-video-item"
                v-if="item.spjh.length == 1 || item.spjh.length == 2 "
              >
                <img src="@/assets/img/videoDetail/banner2.png" alt="">
                <div>
                  <p class="title">亚健康、小病小痛怎么办</p>
                  <p class="content">深读十几万三甲医院医生在线等你</p>
                </div>
              </li>
              <li
                class="relative-video-item"
                v-if="item.spjh.length < 3 &&  item.spjh.length != 2"
                @click="goDetail(262, 0)"
              >
                <img src="@/assets/img/videoDetail/banner3.png" alt="">
                <div>
                  <p class="title">兄弟你持久吗</p>
                  <p class="content">《早泄专题》上线啦，你懂呦</p>
                </div>
              </li>
            </ul>
          </div>
        </template>
      </div>
      <!-- 查看全部视频 -->
      <div v-show="tabIndex == 0" @click="seeAllGroupDetail" class="seeAllGroupDetail">查看全部视频 ></div>
      <div class="block-line"></div>
      <div class="content-box-normal">
        <!-- 小知识点 -->
        <div
          v-if="douyinList.length && (itemData.issf == 1 && itemData.jf || itemData.issf == 2 )"
          class="other-sorts border-css"
        >
          <p class="other-name title-css">小知识点</p>
          <template v-for="(douyin, key ) in douyinList">
            <div
              class="kownLedge"
              @click="exchangeKownLedge(douyin.aliyun_mp4_play_url, douyin.aliyun_cover_url, douyin.id)"
              :key="key"
            >
              <img src="@/assets/img/videoDetail/kownLedge.png" alt="" class="icon">
              <p :class="[ douyin.id == kownLedgeVideoId && 'active']">{{ douyin.video_title }}</p>
            </div>
          </template>
        </div>
        <!-- 看病就医 -->
        <div class="doctor-wrapper">
          <!-- <doctor-detail  :departmentId='departmentId' :group_id='group_id'></doctor-detail> -->
          <template v-for="(doctor, key) in relativeDoctors">
            <doctor-detail :item="doctor" :isShowTilte="key == 0 ? true: false" :key="key"></doctor-detail>
          </template>
        </div>
        <!-- end -->
      </div>
      <!-- <div  v-if='tabIndex == 0'  class="content-box-normal top">
      <p class="other-name title-css">相关视频</p>
      </div>-->

      <!-- 相关兵种 -->
      <!-- <div v-if='tabIndex == 0' class="other-sorts border-css" style="margin-top: 0 ">
        <div class="scroll-box">
          <ul class="item-wrapper">
            <li class="item-list" v-for="(item,index) in relatedDiseases" :key="index">
              <div class="img-box" @click="goVideo(item)">
                <img :src="item.item_info.aliyun_cover_url" alt="" class="list-img">
                <span class="tips">{{item.episode_text}}</span>
              </div>
              <span class="list-name">{{item.group_name}}</span>
              <div class="video-shdow-wrapper" @click="goVideo(item)">
                <img src="../../assets/img/common-img/bgc-img.png" alt="" class="video-shdow">
              </div>
            </li>
            <li class="item-bottom" v-if="!relatedDiseases.length>0">
              <p>深读君挑灯夜战正在赶制。。。。</p>
            </li>
          </ul>
        </div>
      </div>-->

      <!-- end -->
      <!-- <div v-show='tabIndex == 0' class="content-box-normal">
         <div class="other-sorts ">
            <p class="other-name title-css">{{ relateVideos.dpInfo.title }}</p>
          </div>
      </div>-->
      <!-- <div v-show='tabIndex == 0' class="block"></div> -->
      <!-- end  -->
      <!-- 评论 -->
      <div v-show="tabIndex == 0" class="content-box-normal bottom">
        <div class="comment-box" id="comment-list">
          <span class="comment-name title-css">评论</span>
          <ul class="comment-list" v-if="commentList.commentList">
            <li class="item-list" v-for="(item,index) in commentList.commentList" :key="index">
              <div class="item-left">
                <img
                  src="../../assets/img/see-doctor-icon/1-3pingluntouxiang@2x.png"
                  alt=""
                  class="user-icon"
                >
              </div>
              <div class="item-right">
                <div class="user-info">
                  <span class="user-mobile">{{item.nickname}}</span>
                  <img
                    v-if="item.is_self"
                    src="../../assets/img/see-doctor-icon/1-3pinglunshanchu@2x.png"
                    alt=""
                    class="delete-icon"
                    @click="deleteComment(item.comment_id)"
                  >
                </div>
                <p class="comment-text" v-html="emoji(item.content)"></p>
                <span class="comment-time">{{item.time_describe}}</span>
              </div>
            </li>
            <li class="item-bottom" v-if="commentList.commentList.length>0">
              <p>评论已经到底了~</p>
            </li>
            <li class="item-bottom" v-if="!commentList.commentList.length>0">
              <p>还没有评论，要不您来两句~</p>
            </li>
            <!-- <li id="comment-flag"></li>
            <div id="scroll-flag"></div>-->
          </ul>
        </div>
        <!-- end -->
        <!-- 阴影未完成！！ -->
        <!-- end -->
        <!-- 留下评论 -->
        <!-- end -->
      </div>
      <div v-show="tabIndex== 0 " class="go-comment">
        <div class="bottom-shadow"></div>
        <!-- <img v-if="!isFavort && sendImg === false" src="../../assets/img/see-doctor-icon/1-3shoucang@2x.png" alt="" class="heart-icon heart-left" @click="collectVideo"> -->

        <img
          v-if="!isFavort && sendImg === false"
          src="../../assets/img/see-doctor-icon/no-collect.png"
          alt=""
          class="heart-icon"
          @click="collectVideo"
        >
        <img
          v-if="isFavort && sendImg === false"
          src="../../assets/img/see-doctor-icon/has_collect.png"
          alt=""
          class="heart-icon"
          @click="cancleCollectVideo"
        >
        <img
          v-if="sendImg === true"
          src="../../assets/img/see-doctor-icon/send-comment.png"
          @click="addComment"
          alt=""
          class="heart-icon"
        >
        <input
          ref="commentRef"
          type="text"
          placeholder="给深读君留言呗~"
          class="comment-text"
          v-model="commentInput"
          @focus="onFocus"
          @keyup.enter="addComment"
        >
      </div>
    </div>
    <!-- 蒙层 -->
    <div v-if="showMongolia" class="mongolia" @touchstart="closeMongolia"></div>
    <van-popup v-model="isShowDepartImage">
      <img
        @click="isShowDepartImage = false"
        class="isShowDepart"
        src="@/assets/img/videoDetail/zaoxie-advert.png"
      >
    </van-popup>
    <!-- 查看全部视频 弹层 -->
    <transition name="popup" transition-mode="in-out">
      <div class="groupVideosPopUp" v-if="isShowGroupDetailPop">
        <div class="header">
          <p>相关视频</p>
          <img @click="closeAllGroupDetailPop" src="@/assets/img/videoDetail/close.png" alt="">
        </div>
        <div class="items-container">
          <template v-for="(video, key) in currentGroupSpjh">
            <div class="items" @click="goDetail(video.item_id, key)" :key="key">
              <img :src="video.image" alt="">
              <div>
                <p class="title">{{ video.tag_name }}</p>
                <p class="content">{{ video.video_name.split("：")[1] }}</p>
              </div>
            </div>
          </template>
        </div>
      </div>
    </transition>
    <!-- end -->
  </div>
</template>

<script>
  //滑动处理
  var startX, startY;
  // import VideoPlayer from '../public/VideoPlayer'
  import DoctorDetail from "../public/DoctorDetail";
  import TcPlayer from "../public/TcPlayer";
  import EventBus from "../../common/eventBus.js";
  import { currentHost } from "@/config";
  import { Wechat } from "@/common/Wechat";
  import { emoji } from "@/common/emoji";
  // import emoji from 'emoji'
  export default {
    data() {
      return {
        itemId: "",
        itemData: [],
        departmentId: "",
        group_id: "",
        doctor_id: "",
        relatedDiseases: [],
        relateVideos: {
          dpInfo: {},
          groupList: {}
        },
        commentList: [],
        commentInput: "",
        isShowTips: true,
        url: "",
        isFavort: null,
        sendImg: false, // 控制发送图标
        activeIndex: null,
        backPath: "", // 记录要回退的地址s
        showShdow: true,
        iosBottom: null,
        showBack: true,
        showMongolia: false,
        tabIndex: 0, // 视频：0 图文 ： 1
        isShowBuyPanel: false, // 是否显示收费面板
        prepareWatch: true, // 试看
        isAutoLoad: false,
        payStatusTimer: null,
        douyinList: [],
        isPlayKownLedgeVideo: false, // 是否在播 小知识点视频
        kownLedgeVideoId: 0, // 小知识点视频id， 判断 active
        kownLedgeContent: "",
        isShowDepartImage: false, // 是否显示弹窗
        playTime: 0,
        relativeDoctors: [], // 相关医生
        startScrollPos: null,
        currentSwiperIndex: 0,
        isShowGroupDetailPop: false,
        currentGroupSpjh: []
      };
    },
    created() {
      if (!sessionStorage.getItem("originRouter")) {
        sessionStorage.setItem("originRouter", this.$route.query.itemId);
      }
      if (this.$route.query.itemId) {
        this.itemId = this.$route.query.itemId; //! !!!!!!!!!!!写死的一个假数据
      }
      if (localStorage.getItem("commentData") !== "") {
        // 评论信息
        this.commentInput = localStorage.getItem("commentData");
      }
      this.fetch();
      this.getComment();
    },
    beforeMount() {
      this.activeIndex = this.$route.query.itemId;
    },
    mounted() {
      if (this.$route.query.itemId) {
      }
      // 定制运营功能
      let staff_id, url_id; // 人员id、URL链接id
      if (this.$route.query.staff_id) {
        staff_id = this.$route.query.staff_id;
        url_id = this.$route.query.url_id;
        localStorage.setItem("staff_id", staff_id);
        localStorage.setItem("url_id", url_id);
      } else {
        staff_id = localStorage.getItem("staff_id");
        url_id = localStorage.getItem("url_id");
      }
      this.$http.post(
        "/user/share_account",
        this.$ObjToFd({
          url: encodeURIComponent(location.href),
          staff_id,
          url_id
        })
      );

      // this.commentRef.blur()
      if (this.$route.path === "/SdDetailVideo") {
        this.showShdow = false;
      }
      let that = this;
      EventBus.$on("showBack", val => {
        that.showBack = val;
      });
      EventBus.$on("hiddenBack", val => {
        that.showBack = val;
      });
      if (localStorage.getItem("token")) {
        this.isCollect();
      }
    },
    beforeRouteEnter(to, from, next) {
      const path = to.fullPath;
      const origin = location.origin;
      var obj = [
        "?from=timeline&isappinstalled=0",
        "?from=groupmessage&isappinstalled=0",
        "?from=singlemessage&isappinstalled=0"
      ];
      if (location.href.indexOf("?from=") > -1) {
        // this.$router.push("/index")
        console.log(origin + "/#" + to.fullPath);
        location = origin + "/#" + to.fullPath;
        return;
      }
      next(vm => {
        if (from.path !== vm.$route.path) {
          vm.backPath = from.path;
          if (from.path === "/SdDoctorMsg" || from.path === "/SdInquiry") {
            sessionStorage.setItem("videoBackPath", "/SdSeeDoctor");
          } else {
            sessionStorage.setItem("videoBackPath", vm.backPath);
          }
        }
      });
    },
    beforeDestroy() {
      EventBus.$off("showBack");
      EventBus.$off("hiddenBack");
      const doc = this.$refs["related-swiper-box"];
      clearInterval(doc.timer);
      clearInterval(this.iosBottom);
    },
    destroyed() {
      if (this.commentInput) {
        if (this.commentInput.length > 0) {
          localStorage.setItem("commentData", "");
          localStorage.setItem("commentData", this.commentInput);
        }
      }
      clearInterval(this.iosBottom);
    },
    watch: {
      itemId(n, o) {
        // EventBus.$off('showBack')
        // EventBus.$off('hiddenBack')
        if (!o) {
          return;
        }
        this.isPlayKownLedgeVideo = false;
        this.fetch();
        this.getComment();
        this.playTime = 0; // 视频播放次数清零
        if (localStorage.getItem("token")) {
          this.isCollect();
        }
        window.scrollTo(0, 0);
      },
      showMongolia: {
        handler(n, o) {
          if (n === false) {
            clearInterval(this.iosBottom);
          }
        }
      }
    },
    inject: ["reload", "setGlobalCss"],
    components: {
      // 'video-player': VideoPlayer,
      "doctor-detail": DoctorDetail,
      "tc-player": TcPlayer
    },
    beforeDestroy() {
      this.setGlobalCss(false);
      if (this.payStatusTimer) {
        clearInterval(this.payStatusTimer);
      }
    },
    methods: {
      emoji: emoji,
      getRelatedVideos() {
        this.$http
          .get("/home/other_group", {
            params: { department_id: this.departmentId }
          })
          .then(res => {
            this.relateVideos = res.data.data;
          });
      },
      // 查看全部视频
      seeAllGroupDetail() {
        this.currentGroupSpjh = this.relateVideos.groupList[
          this.currentSwiperIndex
        ].spjh;
        this.isShowGroupDetailPop = true;
      },
      closeAllGroupDetailPop() {
        this.isShowGroupDetailPop = false;
      },
      //返回角度
      GetSlideAngle(dx, dy) {
        return (Math.atan2(dy, dx) * 180) / Math.PI;
      },

      //根据起点和终点返回方向 1：向上，2：向下，3：向左，4：向右,0：未滑动
      GetSlideDirection(startX, startY, endX, endY) {
        var dy = startY - endY;
        var dx = endX - startX;
        var result = 0;
        //如果滑动距离太短
        if (Math.abs(dx) < 2 && Math.abs(dy) < 2) {
          return result;
        }
        var angle = this.GetSlideAngle(dx, dy);
        if (angle >= -45 && angle < 45) {
          result = 4;
        } else if (angle >= 45 && angle < 135) {
          result = 1;
        } else if (angle >= -135 && angle < -45) {
          result = 2;
        } else if (
          (angle >= 135 && angle <= 180) ||
          (angle >= -180 && angle < -135)
        ) {
          result = 3;
        }
        return result;
      },
      bindRelateTouchStart(e) {
        const touch = e.changedTouches[0];
        const pageX = touch.pageX;
        this.startScrollPos = pageX;
        startX = touch.pageX;
        startY = touch.pageY;
      },
      // bindRelateTouchMove (e) {
      //     e.preventDefault();
      //     moveEndX = e.changedTouches[0].pageX
      //     moveEndY = e.changedTouches[0].pageY
      //     X = moveEndX - startX
      //     Y = moveEndY - startY
      //     if ( X > 0 ) {console.log('向右')}
      //     else if ( X < 0 ) {console.log('向左')}
      //     else if ( Y > 0) {console.log('向下')}
      //     else if ( Y < 0 ) { console.log('向上')}
      //     else{console.log('没滑动') }
      // },
      bindRelateTouchEnd(ev) {
        console.log("end");
        var endX, endY;
        endX = ev.changedTouches[0].pageX;
        endY = ev.changedTouches[0].pageY;
        const touch = ev.changedTouches[0];
        const pageX = touch.pageX;
        const offsetX = Math.abs(pageX - this.startScrollPos);
        const screenWidth = screen.availWidth;
        // 临界点 ， 超过就可以滑动
        const criticalValue = screenWidth * (1 / 7);
        var direction = this.GetSlideDirection(startX, startY, endX, endY);

        if (direction == 0 || direction == 1 || direction == 2) {
          this.recoverPos();
          return;
        }
        if (criticalValue < offsetX) {
          if (direction == 3) {
            console.log("向左");
            this.skipNextSwiper();
          } else if (direction == 4) {
            console.log("向右");
            this.skipPrevSwiper();
          }
        } else {
          console.log("没超过临界点复位");
          // 没超过临界点复位
          this.recoverPos();
        }
        // 滑动距离
        // if( offsetX > 0 ) {
        //   console.log( "右滑 上一张", offsetX )
        //   this.skipPrevSwiper()
        // }
        // else{
        //   console.log( "左滑 下一张", offsetX )
        //   this.skipNextSwiper()
        // }
      },
      recoverPos() {
        console.log("复位");
        const doc = this.$refs["video-swiper-item"][0];
        this.scrollToPos(doc.clientWidth * this.currentSwiperIndex);
      },
      skipNextSwiper() {
        this.currentSwiperIndex += 1;
        if (this.currentSwiperIndex >= this.relateVideos.groupList.length) {
          this.currentSwiperIndex = this.relateVideos.groupList.length - 1;
        }
        const doc = this.$refs["video-swiper-item"][this.currentSwiperIndex];
        console.log(doc.clientWidth * this.currentSwiperIndex);
        this.scrollToPos(doc.clientWidth * this.currentSwiperIndex);
      },
      skipPrevSwiper() {
        this.currentSwiperIndex -= 1;
        if (this.currentSwiperIndex < 0) {
          this.currentSwiperIndex = 0;
        }
        const doc = this.$refs["video-swiper-item"][this.currentSwiperIndex];
        console.log(
          doc.clientWidth * this.currentSwiperIndex,
          this.currentSwiperIndex
        );
        this.scrollToPos(doc.clientWidth * this.currentSwiperIndex);
      },
      // 定位swpier 位置
      scrollToPos(position) {
        const doc = this.$refs["related-swiper-box"];
        //this.scrollAnimation(position)
        this.scrollAnimate2(doc, position);
        //doc.scrollLeft = position
        this.startScrollPos = null;
      },
      // 让 任意对象 移动到 指定位置
      scrollAnimate2(obj, target) {
        clearInterval(obj.timer);
        var lastScorllDistance = null;
        obj.timer = setInterval(function() {
          var leader = obj.scrollLeft;
          console.log("scrollLeft", leader);
          console.log("target", target);
          var step = (target - leader) / 8;
          console.log(step);
          step = step > 0 ? Math.ceil(step) : Math.floor(step);
          leader = leader + step;
          lastScorllDistance = leader;
          obj.scrollLeft = leader;

          if (leader === target) {
            clearInterval(obj.timer);
          }
        }, 15);
      },
      scrollAnimation(targetX) {
        // 获取当前位置方法
        // const currentY = document.documentElement.scrollTop || document.body.scrollTop
        const doc = this.$refs["related-swiper-box"];
        // 计算需要移动的距离
        const currentX = doc.scrollLeft;
        let needScrollLeft = targetX - currentX;
        //console.log(targetY, currentY)
        let _currentX = currentX;
        setTimeout(() => {
          // 一次调用滑动帧数，每次调用会不一样
          const dist = Math.ceil(needScrollLeft / 30);
          _currentX += dist;
          // if( needScrollLeft <= 10 && needScrollLeft >= -10 ) {
          //   return
          // }
          doc.scrollLeft = _currentX;
          //window.scrollTo(_currentX, currentX)
          // 如果移动幅度小于十个像素，直接移动，否则递归调用，实现动画效果
          if (needScrollLeft > 10 || needScrollLeft < -10) {
            //console.log("scrolling")
            this.scrollAnimation(targetX);
          } else {
            //window.scrollTo(_currentY, targetY)
            //console.log('scrlllend')
            doc.scrollLeft = _currentX;
          }
        }, 1);
      },
      getKownLedgeContent() {
        this.$http
          .get("/home/douyin_detail", {
            params: { id: this.kownLedgeVideoId }
          })
          .then(res => {
            this.kownLedgeContent = res.data.data.info.content;
          });
      },
      exchangeKownLedge(url, coverUrl, id) {
        this.$refs.player.resetVideo(url, coverUrl);
        this.isPlayKownLedgeVideo = true;
        this.kownLedgeVideoId = id;
        this.getKownLedgeContent();
        this.getComment();
        window.location.href = `https://www.shendutv.com/video/baidu-douyin-detail/${id}.html`
      },
      buyVideo() {
        const token = localStorage.getItem("token");
        if (!token) {
          const routerPath = this.$route.fullPath;
          this.$router.push({
            path: "/sdLogin",
            query: {
              redirect: routerPath,
              loginFrom: routerPath
            }
          });
          return;
        }
        if (this.$isWexin) {
          // 微信支付
          this.weixinPay();
        } else {
          // 手机浏览器
          this.mobileBrowserPay();
        }
      },
      createPayParams() {
        const openid = localStorage.getItem("openid");
        return {
          item_id: this.itemId,
          order_type: this.$isWexin ? 2 : 3,
          openid
        };
      },
      wechatPayCheck(order_number) {
        let step = 0;
        this.payStatusTimer = setInterval(() => {
          this.$http
            .get("/order/select_order_status", {
              params: { order_number }
            })
            .then(res => {
              const { is_pay, trade_status } = res.data.data;
              if (step > 5 * 60) {
                this.$toast("支付超时");
                //this.$router.push('/SdAskOrder')
                return;
              }
              if (is_pay && trade_status == 2) {
                clearInterval(this.payStatusTimer);
                this.$toast("支付成功");
                location.reload();
                return;
              }
              step += 1;
            });
        }, 1000);
      },
      // 手机浏览器支付
      mobileBrowserPay() {
        const url = "/order/create_item_order";
        this.$http.post(url, this.$ObjToFd(this.createPayParams())).then(res => {
          if (res.data.code == 0) {
            const mweb_url = res.data.data.config.result.mweb_url;
            const order_number = res.data.data.order_number;
            this.orderNum = order_number;
            console.log(
              mweb_url +
                "&redirect_url=" +
                encodeURIComponent(
                  currentHost +
                    "/#/payCheck/" +
                    order_number +
                    "/video?itemId=" +
                    this.itemId
                )
            );
            location.href =
              mweb_url +
              "&redirect_url=" +
              encodeURIComponent(
                currentHost +
                  "/#/payCheck/" +
                  order_number +
                  "/video?itemId=" +
                  this.itemId
              );
          }
        });
      },
      // 微信支付
      weixinPay() {
        const { doctor_id } = this.$route.query;
        let params = this.createPayParams();
        const url = "/order/create_item_order";
        this.$http.post(url, this.$ObjToFd(params)).then(res => {
          if (res.data.code == 0) {
            const { prepayId, json } = res.data.data.config;
            const order_number = res.data.data.order_number;
            this.orderNum = order_number;
            if (WeixinJSBridge && prepayId !== "") {
              // 下单成功 WeixinJSBridge
              WeixinJSBridge.invoke("getBrandWCPayRequest", json, res => {
                if (res.err_msg === "get_brand_wcpay_request:ok") {
                  this.wechatPayCheck(order_number); //
                } else {
                  //this.$router.push('/SdAskOrder')
                  this.$toast("支付失败");
                }
              });
            }
          }
        });
      },
      prepareToWatch() {
        this.prepareWatch = false;
        this.$nextTick(() => {
          this.$refs.player.videoPlay();
        });
      },
      // 监控视频播放结束
      videoEnded() {
        if (this.itemData.issf == "1" && !this.itemData.jf) {
          this.isShowBuyPanel = true;
        }
      },
      // 监控视频播放， 但没次只记录一次
      videoPlay() {
        if (this.playTime > 0) {
          return;
        } else {
          const issf = this.itemData.issf; // 是否需要缴费
          const jf = this.itemData.jf; // 是否缴费
          const type = issf == 2 ? 1 : jf ? 1 : 2;
          if (localStorage.getItem("token")) {
            this.watchHistory(type);
          } else {
            let params = {
              item_id: this.itemId,
              type
            };
            let url = "/home/play_record";
            this.$http.post(url, this.$ObjToFd(params)).then(res => {});
          }
          this.playTime += 1;
        }
      },
      computedVideoItemClass(item) {
        const issf = item.issf; // 是否需要购买 1 : 要收费 2. 不用收费
        const jf = item.jf; // 是否buy
        if (
          issf == "1" &&
          jf &&
          this.activeIndex == item.item_id &&
          !this.isPlayKownLedgeVideo
        ) {
          return "active";
        } else if (
          issf == "2" &&
          this.activeIndex == item.item_id &&
          !this.isPlayKownLedgeVideo
        ) {
          return "active";
        } else if (issf == "1" && !jf) {
          return "lock";
        }
        return "";
      },
      setTabIndex(tab) {
        if (tab == 0) {
          this.setGlobalCss(true);
        } else {
          if (this.itemData.issf == "1" && !this.itemData.jf) {
            if (this.isMinProgamme) {
              this.$toast("请到公众号观看");
            } else {
              this.$toast("请先购买该视频");
            }
            return;
          }
          this.setGlobalCss(false);
          document.body.scrollTop = document.documentElement.scrollTop = 0;
        }
        this.tabIndex = tab;
      },
      fetch() {
        let params = {
          item_id: this.itemId
        };
        let url = `/home/video_detail?item_id=${params.item_id}`;
        this.$http.get(url).then(res => {
          if (res.data.code == 0) {
            this.itemData = res.data.data;
            //console.log(this.itemData, '视频详情')
            this.departmentId = res.data.data.department_id;
            const groupId = res.data.data.group_id;
            if (groupId == 68 && !localStorage.getItem("hasGroupId-" + groupId)) {
              localStorage.setItem("hasGroupId-" + groupId, 1);
              this.isShowDepartImage = true; // 自动弹出
            }

            this.group_id = res.data.data.group_id;
            this.getRelaDis();
            this.getDouYinList();
            this.getRelativeDoctors();
            this.getRelatedVideos();
            const wechat = Wechat.getInstance();
            const data = {
              title: "深读视频精选：" + this.itemData.tag_name, // 分享标题
              desc: this.itemData.long_name, // 分享描述
              link: decodeURIComponent(location.href), // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
              imgUrl: "https://wx.shendutv.com/images/638667815392809725.png" // 分享图标
            };
            wechat.doSomethingAfterWxConfig(this.$http, wechat.weChatShare(data));
          }
        });
      },
      getDouYinList() {
        this.$http
          .get("/home/douyin_list", {
            params: {
              department_id: this.departmentId,
              group_id: this.group_id
            }
          })
          .then(res => {
            console.log("douyin", res);
            this.douyinList = res.data.data;
          });
      },
      onFocus() {
        this.sendImg = true;
        this.showMongolia = true;
        // 解决苹果输入框被钉上去的问题
        this.iosBottom = setInterval(function() {
          document.body.scrollTop = document.body.scrollHeight;
        }, 300);
      },
      onBlur() {
        console.log("blur");
        this.sendImg = false;
        const doc = this.$refs["related-swiper-box"];
        clearInterval(doc.timer);
        clearInterval(this.iosBottom);
      },
      // get相关病种
      getRelaDis() {
        let params = {
          department_id: this.departmentId,
          group_id: this.group_id
        };
        let url = `/home/related_diseases?department_id=${
          params.department_id
        }&group_id=${params.group_id}`;
        this.$http.get(url).then(res => {
          if (res.data.code == 0) {
            this.relatedDiseases = res.data.data;
          } else {
            this.$toast(res.data.message);
          }
        });
      },
      // get 视频评论
      getComment() {
        let params = {
          item_id: this.isPlayKownLedgeVideo
            ? this.kownLedgeVideoId
            : this.itemId,
          page: 1,
          number: 100,
          type: this.isPlayKownLedgeVideo ? "2" : "1" // type : 1 病种 2: 抖音
        };
        let url = `/home/video_comment_list`;
        this.$http
          .get(url, {
            params
          })
          .then(res => {
            if (res.data.code == 0) {
              this.commentList = res.data.data;
            }
          });
      },
      goWx(http) {
        window.location.href = http;
      },
      goDetail(val, index) {
        event.stopPropagation();
        this.isShowGroupDetailPop = true;
        this.itemId = val;
        this.activeIndex = val;
        // this.$router.go(-1)
        this.$router.push({ path: "/SdDetailVideo", query: { itemId: val } });
        // location.reload()
        this.reload();
      },
      getRelativeDoctors() {
        const url = "/home/recommend_doctor_wx";
        this.$http
          .get(url, {
            params: {
              group_id: this.group_id
            }
          })
          .then(res => {
            if (res.data.code == 0) {
              this.relativeDoctors = res.data.data;
            }
          });
      },
      goBack() {
        this.commentInput = "";
        if (localStorage.getItem("commentData")) {
          localStorage.removeItem("commentData");
        }
        if (window.history.length <= 1) {
          console.log("返回首页");
          this.$router.push({ path: "/SdSeeDoctor" });
          sessionStorage.removeItem("originRouter");
          return false;
        } else {
          if (
            sessionStorage.getItem("originRouter") == this.$route.query.itemId
          ) {
            console.log("返回首页2");
            this.$router.push({ path: "/SdSeeDoctor" });
            sessionStorage.removeItem("originRouter");
          } else {
            // console.log("返回专题页");
            // this.$router.go(-1);
            this.$router.push(
              "/SdGroupDetail?itemId=" + sessionStorage.getItem("originRouter")
            );
          }
          console.log(this.$route.query);
          // window.history.go( -1 );
        }
      },
      // 添加评论
      addComment() {
        if (this.commentInput === null) {
          this.$toast("输入信息为空");
        } else {
          let params = {
            item_id: this.isPlayKownLedgeVideo
              ? this.kownLedgeVideoId
              : this.itemId,
            type: this.isPlayKownLedgeVideo ? "2" : "1", // type : 1 病种 2: 抖音
            content: this.utf16toEntities(this.commentInput)
          };
          let url = "/home/video_comment_add";
          this.$http.post(url, this.$ObjToFd(params)).then(res => {
            if (res.data.code == 0) {
              this.$toast("留言成功");
              this.closeMongolia();
              this.getComment();
              this.commentInput = "";
              this.toBottom();
              this.$refs.commentRef.blur();
              localStorage.removeItem("commentData");
            } else {
              if (res.data.error === 9999) {
                this.$router.push({
                  path: "/SdLogin",
                  query: {
                    redirect: `${this.$route.path}?itemId=${params.item_id}`
                  }
                });
              }
            }
          });
        }
      },
      // 跳转底部
      toBottom() {
        let scroll = document.getElementById("comment-list");
        window.scrollTo(0, scroll.offsetTop);
      },
      // 删除评论
      deleteComment(val) {
        let params = {
          ids: val
        };
        let url = "/home/video_comment_delete";
        this.$http.post(url, this.$ObjToFd(params)).then(res => {
          if (res.data.code == 0) {
            this.$toast("删除成功");
            this.getComment();
          } else {
            this.$toast(res.data.message);
          }
        });
      },
      // 收藏视频
      collectVideo(val) {
        let url = "/home/video_collect_add";
        let params = {
          item_id: this.itemId
        };
        this.$http.post(url, this.$ObjToFd(params)).then(res => {
          if (res.data.code == 0) {
            this.isFavort = true;
            this.$toast("收藏成功");
          } else {
            this.$toast(res.data.message);
          }
        });
      },
      // 取消收藏视频
      cancleCollectVideo(val) {
        let params = {
          item_id: this.itemId
        };
        let url = "home/video_collect_delete";
        this.$http.post(url, this.$ObjToFd(params)).then(res => {
          if (res.data.code == 0) {
            this.$toast("取消成功");
            this.isFavort = false;
          }
        });
      },
      // 观看历史
      watchHistory(type) {
        let params = {
          item_id: this.itemId,
          type
        };
        let url = "/center/add_view_history";
        this.$http.post(url, this.$ObjToFd(params)).then(res => {});
      },
      goSearch(val) {
        this.$router.push({ path: "/SdSearch", query: { key: val } });
      },
      // 跳转至定向医生详情
      goDoctor(item) {
        // this.$router.push()
      },
      // 相关视频去视频详情
      goVideo(val) {
        this.itemId = val.item_info.item_id;
        this.$router.push({
          path: "/SdDetailVideo",
          query: { itemId: val.item_info.item_id }
        });
        this.reload();
      },
      // 判断是否收藏
      isCollect() {
        let params = {
          item_id: this.itemId
        };
        // let url = `home/video_collect?item_id=${params.item_id}`
        let url = `home/video_collect?item_id=${params.item_id}`;
        this.$http.get(url).then(res => {
          this.isFavort = res.data.data;
        });
      },
      // 输入框聚焦切换图标
      changeImg() {
        this.sendImg = true;
      },
      // emoji
      utf16toEntities(str) {
        var patt = /[\ud800-\udbff][\udc00-\udfff]/g; // 检测utf16字符正则
        str = str.replace(patt, function(char) {
          var H, L, code;
          if (char.length === 2) {
            H = char.charCodeAt(0); // 取出高位
            L = char.charCodeAt(1); // 取出低位
            code = (H - 0xd800) * 0x400 + 0x10000 + L - 0xdc00; // 转换算法
            return "&#" + code + ";";
          } else {
            return char;
          }
        });
        return str;
      },
      // ===
      testVideo() {
        alert.log("我在点视频aaa ");
      },
      test() {
        let params = this.$refs.playerRef;
        params.onclick = null;
        // alert('...')
      },
      // 点击蒙层输入框失去焦点
      closeMongolia() {
        this.showMongolia = false;
        this.sendImg = false;
        this.$refs.commentRef.blur();
        const doc = this.$refs["related-swiper-box"];
        clearInterval(doc.timer);
        clearInterval(this.iosBottom);
        //this.onBlur()
      },
      // 区人保
      goInsurance() {
        window.location.href = "https://wx.shendutv.com/insurance/renbao";
      }
    }
  };
</script>
<style>
  @import "../../assets/css/emoji.less";
  .emoji-span {
    width: 25px;
    height: 25px;
    display: inline-block;
    border: 1px solid transparent;
    cursor: pointer;
  }
  [class*="sprite-"] {
    width: 25px;
    height: 25px;
    background-image: url("~@/assets/img/common-img/vue-emoji.png");
    background-repeat: no-repeat;
    vertical-align: top;
    display: inline-block;
    background-size: 882.8125px 867.1875px;
    /* transform: scale(1.2, 1.2) */
  }
  #detail-video .van-popup {
    background-color: transparent;
  }
</style>


<style lang="postcss" scoped>
  .isShowDepart {
    width: 553px;
    height: 628px;
  }
  #detail-video {
    height: 100%;
    background-color: #fffffd;
    /* pointer-events: none; */
    & .mongolia {
      height: 100vh;
      width: 100vw;
      background-color: white;
      opacity: 0;
      /* z-index: 9999; */
      z-index: 10;
      position: fixed;
      top: 0;
    }
    & .top-title {
      width: 100%;
      padding: 27px 0;
      top: 0;
      position: fixed;
      width: 100%;
      z-index: 999;
      display: flex;
      justify-content: center;
      border-bottom: 1px solid #fffffd;
      background-color: #fffffd;
      box-shadow: 1px 8px 60px rgba(0, 0, 0, 0.1);
      z-index: 999999;
      & .back-icon {
        width: 34px;
        height: 34px;
        position: absolute;
        left: 30px;
      }
      & .title-text {
        font-size: 34px;
        font-family: "SourceHanSansCN Medium";
        font-weight: 400;
      }
    }
    & .video-wrapper {
      background-color: #fffffd;
      flex-direction: column;
      /* margin-top: 88px; */
      position: fixed;
      top: 0px;
      z-index: 1000 !important;
      /* position: relative; */
      width: 100%;
      height: 422px;
      /* background-color: red; */
      overflow: hidden !important;
      pointer-events: auto;
      & .video-item {
        width: 100%;
        height: 100%;
        /* overflow: hidden; */
        position: relative;
        margin-bottom: 14px;
        & .tcplayer-box {
          pointer-events: auto;
          z-index: 1000;
        }
        & .name-box {
          display: flex;
          width: 100%;
          justify-content: space-between;
          align-items: center;
          background-color: #fff;
          & .video-name {
            font-size: 28px;
            font-family: SourceHanSansCN-Regular;
            font-weight: 400;
            color: rgba(102, 102, 102, 1);
            margin: 37px 0 37px 25px;
            z-index: 222;
          }
          & .chat-online {
            background: rgba(55, 189, 25, 1);
            border-radius: 22px;
            width: 160px;
            height: 44px;
            margin-right: 30px;
            font-size: 28px;
            font-family: SourceHanSansCN-Medium;
            font-weight: 500;
            color: rgba(255, 255, 255, 1);
          }
        }
        & .iqiyi-video-name {
          font-size: 36px;
          font-family: SourceHanSansCN-Medium;
          font-weight: 500;
          color: rgba(255, 255, 255, 1);
          line-height: 40px;
          text-shadow: 0px 2px 2px rgba(0, 0, 0, 0.4);
          position: absolute;
          top: 21px;
          left: 25px;
          width: 620px;
          z-index: 9999;
        }
        & .top-shdow {
          position: absolute;
          top: 0;
          z-index: 1;
          height: 100px;
          width: 100%;
          /* opacity: 0.2; */
        }
        & .bottom-shdow {
          position: absolute;
          bottom: 100px;
          height: 100px;
          width: 100%;
          z-index: 1;
        }
      }
    }
    & .pay-panel {
      position: fixed;
      z-index: 2000;
      width: 100%;
      height: 422px;
      top: 0;
      left: 0;
      overflow: hidden !important;
      pointer-events: auto;
      background-size: 100%;
      &.pay {
        background: url("~@/assets/img/videoDetail/beijing@2x.png") 0 0 no-repeat;
      }
      & p {
        font-family: SourceHanSansCN-Regular;
        color: #fff;
        font-size: 30px;
        position: absolute;
        top: 122px;
        width: 100%;
        text-align: center;
      }
      & .mask {
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        position: absolute;
      }
      & .shown-btn {
        width: 308px;
        height: 82px;
        position: absolute;
        left: 41px;
        top: 310px;
      }
      & .shown-btn-2 {
        width: 669px;
        height: 92px;
        position: absolute;
        left: 41px;
        top: 300px;
      }
      & .full-watch-btn {
        width: 322px;
        height: 82px;
        right: 40px;
        top: 310px;
        position: absolute;
      }
      & .discount-bg {
        width: 172px;
        height: 29px;
        text-align: center;
        background: url("~@/assets/img/videoDetail/discount-bg.png") 0 0 no-repeat;
        background-size: 100%;
        color: #fff;
        font-family: SourceHanSansCN-Regular;
        position: absolute;
        font-size: 20px;
        line-height: 1.3;
        &.full {
          top: 290px;
          left: 552px;
        }
        &.desc {
          left: 312px;
          top: 242px;
        }
      }
      & .cover-url {
        width: 100%;
        height: 100%;
      }
      & .buy-at-once {
        width: 164px;
        position: absolute;
        left: 50%;
        top: 262px;
        transform: translateX(-50%);
      }
      & .discount-desc {
        width: 172px;
        left: 312px;
        top: 210px;
        position: absolute;
      }
    }
    & .border-wrapper {
      width: 100%;
      & .border-box {
        margin: 0 30px;
        border: 1px solid rgba(215, 215, 215, 1);
      }
    }
    & .title-css {
      font-size: 36px;
      font-family: SourceHanSansCN-Bold;
      font-weight: bold;
      color: rgba(51, 51, 51, 1);
    }
    & .border-css {
      padding-bottom: 55px;
      border-bottom: 1px solid rgba(215, 215, 215, 1);
    }
    & .video-tips {
      position: fixed;
      top: 0;
      width: 100%;
      /* height: 300px; */
      z-index: 2000;
      /* background-color: red; */
      pointer-events: auto;
      & .back-icon {
        width: 60px;
        height: 60px;
        margin-left: 30px;
        margin-top: 30px;
        z-index: 999;
        /* background-color: red; */
      }
      & .eye-box {
        position: absolute;
        bottom: 31px;
        right: 31px;
        display: flex;
        align-items: center;
        font-size: "SourceHanSansCN-Regular";
        color: #fff;
        & .eye-icon {
          width: 28px;
          height: 28px;
          margin-right: 10px;
        }
      }
    }
    & .content-box {
      padding: 0 30px;
      padding-bottom: 88px;
      &.noBottom {
        padding-bottom: 0;
      }
      background-color: #fffffd;
      /* padding-top: 50px; */
      /* padding-top:550px; */
      //position: absolute;
      //top:530px;
      padding-top: 530px;
      width: 100%;
      box-sizing: border-box;
      pointer-events: auto;
      /* height: 100%; */
      /* padding-top: 430px; */
      /* border-top:1px solid rgba(215,215,215,1); */
    }
    & .content-box-normal {
      padding: 0 30px;
      &.bottom {
        padding-bottom: 88px;
      }
      &.top {
        padding-top: 50px;
      }
      background-color: #fffffd;
      /* padding-top: 50px; */
      /* padding-top:550px; */
      //position: absolute;
      //top:530px;
      width: 100%;
      box-sizing: border-box;
      pointer-events: auto;
      /* height: 100%; */
      /* padding-top: 430px; */
      /* border-top:1px solid rgba(215,215,215,1); */
    }
    & .video-name-box {
      margin-top: 30px;
      /* & .video-name {
            font-size: 36px;
            font-family: SourceHanSansCN-Bold;
            font-weight: bold;
            color: rgba(51, 51, 51, 1);
          } */
      & .video-name {
        font-family: SourceHanSansCN-Bold;
        font-weight: bolder;
      }
      & .more-box {
        position: relative;
        display: flex;
        justify-content: space-between;
        font-size: 24px;
        font-family: SourceHanSansCN-Regular;
        font-weight: 400;
        color: rgba(102, 102, 102, 1);
        margin-top: 25px;
        padding-bottom: 50px;
        /* align-items: center; */
        & .name-tips {
          line-height: 35px;
          margin-right: 30px;
        }
        & .tipsActive {
          /* height: 35px; */
          display: -webkit-box;
          text-overflow: ellipsis;
          /*! autoprefixer: off */
          -webkit-box-orient: vertical;
          /* autoprefixer: on */
          overflow: hidden;
          -webkit-line-clamp: 3;
        }
        & .more-icon {
          width: 20px;
          height: 12px;
          margin-top: 3px;
          padding: 10px;
          position: absolute;
          right: -10px;
          top: 68px;
        }
      }
      & .noButtonFlag {
        border-bottom: 1px solid rgba(215, 215, 215, 1);
      }
      & .go_insurance {
        width: 100%;
        height: 54px;
        border-radius: 50px;
        font-size: 30px;
        font-family: "SourceHanSansCN-Medium";
      }
    }
    & .select-box {
      & .select-title {
        margin-top: 50px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 36px;
        font-family: SourceHanSansCN-Bold;
        font-weight: bold;
        color: rgba(51, 51, 51, 1);
        background-color: #fffffd;
        & .title-tips {
          font-size: 26px;
          font-family: SourceHanSansCN-Regular;
          font-weight: 400;
          color: rgba(153, 153, 153, 1);
          margin-left: 20px;
        }
      }
      & .select-video-item-box-wrap {
        font-size: 0;
        width: 100vw;
        margin-left: -30px;
        height: 140px;
        overflow-y: hidden;
        margin-top: 30px;
        margin-bottom: 30px;
        & .select-video-item-box {
          overflow-x: auto;
          white-space: nowrap;
          padding-bottom: 25px;
          & div:first-child {
            margin-left: 30px;
          }
          & .select-video-item {
            display: inline-block;
            width: 203px;
            //height: 140px ;
            line-height: 1;
            padding-top: 59px;
            padding-bottom: 56px;
            text-align: center;
            color: #333;
            font-size: 26px;
            background-color: #e5e5e5;
            border-radius: 10px;
            margin-right: 30px;
            position: relative;
            &.lock {
              background-color: #f2f2f2;
              color: #999;
            }
            &.active {
              color: #76ff00;
              background-color: #454545;
            }
            & .lock-logo {
              width: 25px;
              position: absolute;
              right: 12px;
              top: 10px;
            }
          }
        }
      }

      & .select-button {
        margin-top: 30px;
        & .button-wrapper {
          display: flex;
          & .button-item {
            width: 80px;
            display: flex;
            flex-direction: column;
            align-items: center;
            margin-right: 30px;
            & .button-box {
              height: 80px;
              width: 80px;
              background: rgba(229, 229, 229, 1);
              border-radius: 10px;
              display: flex;
              justify-content: center;
              align-items: center;
              font-size: 26px;
              font-family: SourceHanSansCN-Regular;
              font-weight: 400;
              color: rgba(51, 51, 51, 1);
              flex-direction: column;
            }
            & .img-text {
              margin-top: 14px;
              font-size: 24px;
              font-family: SourceHanSansCN-Regular;
              color: rgba(51, 51, 51, 1);
              border: 1px solid rgba(215, 215, 215, 1);
              padding: 8px 15px;
              border-radius: 10px;
            }
          }
        }
      }
    }
    & .sorts-box {
      margin-top: 50px;
      & .sorts-name {
        font-size: 36px;
        font-family: SourceHanSansCN-Bold;
        font-weight: bold;
        color: rgba(51, 51, 51, 1);
      }
      & .sorts-tips {
        margin: 30px 0 0 0;
        display: flex;
        flex-wrap: wrap;
        & .tips-item {
          /* width: 88px; */
          /* min-width: 80px;
              max-width: 180px; */
          /* width: 50%; */
          padding: 0 10px;
          height: 36px;
          margin-right: 30px;
          /* border: 1px solid rgba(175, 85, 49, 1); */
          /* border-radius: 8px; */
          font-size: 28px;
          font-family: SourceHanSansCN-Regular;
          font-weight: 400;
          color: rgba(175, 85, 49, 1);
          display: flex;
          /* justify-content: center; */
          align-items: center;
          margin-bottom: 20px;
          /* margin-right: 30px; */
          & span {
            border: 1px solid rgba(175, 85, 49, 1);
            border-radius: 8px;
            padding: 0 10px;
            height: 36px;
            line-height: 36px;
            display: flex;
            &.special {
              color: #30747a;
              border-color: #30747a;
            }
            &.normal {
              color: #258714;
              border-color: #258714;
            }
            /* align-items: center; */
          }
        }
        & li:last-child {
          margin-bottom: 0;
        }
      }
      & .sorts-other {
        font-size: 28px;
        font-family: SourceHanSansCN-Regular;
        font-weight: 400;
        color: rgba(37, 135, 20, 1);
        border: 1px solid rgba(37, 135, 20, 1);
        border-radius: 8px;
        padding: 3px 10px;
        margin-bottom: 0;
      }
    }
    & .advert-banner {
      border-bottom: 1px solid #d7d7d7;
      & img {
        width: 100%;
        padding: 50px 0;
      }
    }
    & .doctor-wrapper {
      //margin-top: 50px;
    }
    & .kownLedge {
      position: relative;
      margin-top: 50px;
      & .icon {
        position: absolute;
        top: -10px;
        left: 0;
        width: 48px;
        height: 48px;
      }
      & p {
        font-size: 28px;
        color: #333;
        font-family: SourceHanSansCN-Regular;
        text-align: left;
        width: 613px;
        margin-left: 76px;
        line-height: 40px;
        &.active {
          color: #37bd19;
        }
      }
    }
    & .other-sorts {
      margin-top: 50px;
      & .scroll-box {
        overflow: hidden;
        //height: 296px;
        width: 100%;
        position: relative;
      }
      & .item-wrapper {
        overflow: hidden;
        width: 100%;
        box-sizing: border-box;
        /* position: absolute; */
        padding: 20px 0;
        margin: -20px 0;
        display: -webkit-box;
        overflow-x: scroll;
        -webkit-overflow-scrolling: touch;
        display: flex;
        & li:first-child {
          margin-left: 30px;
        }
        & .item-list {
          position: relative;
          width: 100%;
          margin-right: 30px;
          & .video-shdow-wrapper {
            width: 100%;
            height: 100%;
            z-index: 1;
            position: absolute;
            bottom: 60px;
            & .video-shdow {
              width: 320px;
              height: 150px;
              position: absolute;
              bottom: -16px;
              z-index: 1;
            }
          }
          & .img-box {
            margin: 30px 0;
            width: 320px;
            height: 200px;
            border-radius: 10px;
            overflow: hidden;
            /* background-color: red; */
            position: relative;
            /* margin-right: 30px; */
            & .list-img {
              width: 320px;
              height: 200px;
            }
            & .tips {
              position: absolute;
              bottom: 10px;
              right: 10px;
              font-size: 18px;
              font-family: SourceHanSansCN-Regular;
              font-weight: 400;
              color: rgba(255, 255, 255, 1);
              z-index: 998;
            }
          }
          & .list-name {
            font-size: 28px;
            font-family: SourceHanSansCN-Regular;
            font-weight: 400;
            color: rgba(51, 51, 51, 1);
          }
        }
      }
      & .item-wrapper::-webkit-scrollbar {
        display: none;
      }
    }
    & .comment-box {
      padding-bottom: 60px;
      & .comment-name {
        display: block;
        margin-top: 50px;
      }
      & .comment-list {
        & .item-list {
          display: flex;
          padding: 40px 0;
          /* border-bottom: 1px solid rgba(215, 215, 215, 1); */
          position: relative;
          &::after {
            position: absolute;
            bottom: 0;
            content: "";
            display: block;
            width: 100%;
            height: 1px;
            border: 1px solid rgba(215, 215, 215, 1);
            transform: scaleY(0.3);
          }
          & .item-left {
            height: 90px;
            width: 90px;
            margin-right: 30px;
            & .user-icon {
              width: 90px;
              height: 90px;
            }
          }
          & .item-right {
            width: 100%;
            & .user-info {
              display: flex;
              width: 100%;
              justify-content: space-between;
              font-size: 32px;
              font-family: SourceHanSansCN-Medium;
              font-weight: 500;
              color: rgba(51, 51, 51, 1);
              & .delete-icon {
                width: 27px;
                height: 27px;
              }
            }
            & .comment-text {
              margin: 30px 0;
              width: 570px;
              word-wrap: break-word;
              /* margin-right: 120px; */
              font-size: 28px;
              font-family: SourceHanSansCN-Regular;
              font-weight: 400;
              color: rgba(102, 102, 102, 1);
            }
            & .comment-time {
              font-size: 20px;
              font-family: SourceHanSansCN-Regular;
              color: rgba(153, 153, 153, 1);
            }
          }
        }
      }
    }
    /* & .bottom-shadow {
          width: 100%;
          background: url("../../assets/img/common-img/jianbian-xia@2x.png") repeat-x;
          height: 73px;
          position: absolute;
          bottom: 88px;
        } */
    & .go-comment {
      box-shadow: 1px 8px 60px rgba(0, 0, 0, 0.1);
      position: fixed;
      bottom: 0;
      display: flex;
      font-size: 24px;
      font-family: SourceHanSansCN-Regular;
      color: black;
      background-color: #fffffd;
      width: 100%;
      height: 88px;
      margin-top: 88px;
      box-sizing: border-box;
      padding: 0 30px;
      z-index: 999;
      /* position: relative; */
      & .comment-text {
        width: 100%;
        height: 88px;
        border: 1px solid rgba(255, 255, 253, 1);
        width: 100%;
        min-height: 88px;
        max-height: 100%;
        /* height: 100% */
        border: none;
        /* padding: 0 30px; */
        padding: 0 70px 0 0px;
      }
      & .heart-icon {
        position: absolute;
        width: 40px;
        /* height: 38px;
            right: 55px; */
        right: 30px;
        top: 15px;
        bottom: 30px;
        padding: 10px;
      }
      & .heart-left {
        position: relative;
        width: 40px;
        height: 40px;
        left: 0px;
      }
    }
    & .item-bottom {
      margin-top: 30px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 28px;
      font-family: SourceHanSansCN-Regular;
      font-weight: 400;
      color: rgba(102, 102, 102, 1);
    }
    & #comment-flag {
      height: 10px;
      visibility: hidden;
    }
    /* & .vcp-controls-panel{
          display: none;
        } */
    & .vcp-controls-panel {
      /* height: 50px !important; */
    }
    & .vcp-playtoggle {
      z-index: 9999999;
    }
    & .vcp-panel-bg {
      opacity: 0.5 !important;
    }
    & .activeItem {
      & span {
        color: rgba(55, 189, 25, 1) !important;
      }
    }
    & .test-video {
      width: 100%;
      height: 422px;
    }
    & .tabs-box {
      //height: 98px  ;
      width: 100vw;
      top: 422px;
      position: fixed;
      background-color: #fffffd;
      border-bottom: 1px solid #ededed;
      box-shadow: 0 1px 8px 0 rgba(0, 0, 0, 0.08);
      z-index: 998;
      display: flex;
      justify-content: space-around;
      & .tab {
        line-height: 1;
        text-align: center;
        color: #333;
        flex: 1;
        padding: 34px 0;
        display: inline-block;
        font-family: SourceHanSansCN-Medium;
        font-weight: bold;
        font-size: 32px;
        position: relative;
        &.active {
          color: #37bd19;
        }
        & .lock-logo {
          width: 18px;
          position: absolute;
          top: 50%;
          right: 129px;
          transform: translateY(-50%);
        }
      }
      & .row {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        color: #d7d7d7;
        width: 2px;
      }
    }
    & .line {
      width: 30px;
      height: 4px;
      position: absolute;
      margin: 0;
      margin-top: 12px;
      top: 76px;
      background-color: #37bd19;
      border-radius: 2px;
      &.left {
        left: 172px;
      }
      &.right {
        left: 549px;
      }
    }
    & .related-video-swiper {
      white-space: nowrap;
      overflow-x: scroll;
      vertical-align: top;
      //margin-top: -88px;
      & > div:last-child {
        margin-right: 110px;
      }
      & .video-swiper-item {
        vertical-align: top;
        width: 611px;
        padding-left: 30px;
        height: 716px;
        display: inline-block;
        & .header {
          display: flex;
          align-content: center;
          align-items: center;
          width: 100%;
          margin-top: 40px;
          & .avatur {
            width: 84px;
            height: 84px;
            border-radius: 50%;
            margin-right: 20px;
            object-fit: cover;
          }
          & .name {
            font-size: 36px;
            font-family: SourceHanSansCN-Medium;
            color: #333;
          }
        }
        & ul {
          margin-top: 40px;
          & li:last-child {
            margin-bottom: 0;
          }
        }
        & .relative-video-item {
          display: flex;
          align-content: center;
          align-items: center;
          margin-bottom: 20px;
          & img {
            width: 234px;
            height: 123px;
            margin-right: 20px;
            object-fit: cover;
          }
          & > div {
            & .title {
              font-size: 28px;
              font-family: SourceHanSansCN-Regular;
              font-weight: 400;
              color: #333;
            }
            & .content {
              margin-top: 16px;
              font-size: 24px;
              font-family: SourceHanSansCN-Regular;
              color: #999;
              width: 357px;
              -webkit-box-orient: vertical;
              overflow: hidden;
              line-height: 1;
              text-overflow: ellipsis;
              -webkit-line-clamp: 1;
            }
          }
        }
      }
    }
    & .seeAllGroupDetail {
      width: 690px;
      font-size: 28px;
      color: #333;
      font-family: SourceHanSansCN-Regular;
      background: rgba(245, 245, 245, 1);
      border-radius: 44px;
      text-align: center;
      padding: 30px 0;
      margin: auto;
      margin-top: 30px;
    }
    & .block {
      width: 690px;
      margin: auto;
      height: 50px;
      border-bottom: 1px solid #d7d7d7;
    }
    & .block-line {
      border-bottom: 1px solid #d7d7d7;
      margin: auto;
      width: 690px;
      padding: 30px 0;
    }
    & .groupVideosPopUp {
      box-sizing: border-box;
      padding: 0 30px;
      height: 1212px;
      background-color: #fff;
      position: fixed;
      left: 0;
      top: 422px;
      z-index: 1000;
      width: 100%;

      & .header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 30px 0;
        color: #333333;
        font-size: 32px;
        font-family: SourceHanSansCN-Medium;
        & img {
          width: 24px;
          height: 24px;
        }
      }
      & .items-container {
        position: absolute;
        top: 90px;
        left: 0;
        overscroll-behavior: contain;
        -webkit-overscroll-behavior: contain;
        overflow-y: scroll;
        -webkit-overflow-scrolling: touch;
        overflow-scrolling: touch;
        height: 822px;
        box-sizing: border-box;
        padding: 0 30px;
        width: 100%;
        & > div:last-child {
          padding-bottom: 200px;
        }
      }
      & .items {
        display: flex;
        align-content: center;
        align-items: center;
        margin-bottom: 40px;
        & img {
          width: 268px;
          height: 150px;
          margin-right: 20px;
          object-fit: cover;
        }
        & .title {
          font-family: SourceHanSansCN-Regular;
          color: #333;
          font-size: 28px;
          line-height: 1;
        }
        & .content {
          line-height: 1;
          font-family: SourceHanSansCN-Regular;
          color: #999;
          font-size: 24px;
          margin-top: 30px;
        }
      }
    }
  }
</style>
<style lang="less" scoped>
  .popup-enter-active,
  .popup-leave-active {
    // animation:popup 1s ease-in;
    transition: all 0.5s ease-in;
  }
  .popup-leave-active {
    transition: all 0.3s ease-out;
  }
  .popup-enter, .popup-leave-to /* .fade-leave-active below version 2.1.8 */ {
    //animation:popup 1s reverse ease-out ;
    transform: translateY(1000px);
  }
</style>

<style>
  #detail-video .content-box img {
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/shenduDetailVideo/SdDetailVideo.vue